import { eventNotificationOfqualKeys } from "../../domain/EventNotification";

export const fieldLabels = {
  regulatorsAffectedOfqual: "Regulators to Notify Ofqual",
  regulatorsAffectedCcea: "Regulators to Notify CCEA Regulator",
  regulatorsAffectedQw: "Regulators to Notify Qualification Wales",
  regulatorsAffectedIFATE: "Notify Institute for Apprenticeships and Technical Education (IfATE)",
  orgId: "Awarding Organisation",
  title: "Title",
  dateOfEvent: "Date of Event",
  dateAware: "Date you became aware of the event",
  reasonForDelayInNotifying: "Reason For Delay",
  eventNotificationExamSeries: "Affected Exam Series",
  howBecameAware: "How did you become aware of this event?",
  natureAndCause: "Nature and Cause of Event",
  adverseEffect: "Adverse Effect Type",
  potentialOrActualAdverseEffect: "Adverse Effect Description",
  eventNotificationWhoIsAware: "Who is aware",
  whoIsAwareDetails: "Details",
  dateOfNextUpdate: "Date you provide next update",
  additionalInformation: "More Information",
  informationOnQualsUnitsAffected: "More Information",
  eventNotificationCentres: "Affected Centres",
  englandCentresAffected: "England Centres - Affected",
  englandCentresEntered: "England Centres - No Entered For Unit",
  englandCentresDirectlyAffected: "England Centres - Directly Affected",
  englandCentresIndirectlyAffected: "England Centres - Indirectly Affected",
  englandLearnersEntered: "England Learners - No Entered For Unit",
  englandLearnersDirectlyAffected: "England Learners - Directly Affected",
  englandLearnersIndirectlyAffected: "England Learners - Indirectly Affected",
  walesCentresAffected: "Wales Centres - Affected",
  walesCentresEntered: "Wales Centres - No Entered For Unit",
  walesCentresDirectlyAffected: "Wales Centres - Directly Affected",
  walesCentresIndirectlyAffected: "Wales Centres - Indirectly Affected",
  walesLearnersEntered: "Wales Learners - No Entered For Unit",
  walesLearnersDirectlyAffected: "Wales Learners - Directly Affected",
  walesLearnersIndirectlyAffected: "Wales Learners - Indirectly Affected",
  niCentresAffected: "Northern Ireland - Affected",
  niCentresEntered: "Northern Ireland Centres - No Entered For Unit",
  niCentresDirectlyAffected: "Northern Ireland Centres - Directly Affected",
  niCentresIndirectlyAffected: "Northern Ireland Centres - Indirectly Affected",
  niLearnersEntered: "Northern Ireland Learners - No Entered For Unit",
  niLearnersDirectlyAffected: "Northern Ireland Learners - Directly Affected",
  niLearnersIndirectlyAffected:
    "Northern Ireland Learners - Indirectly Affected",
  otherCentresAffected: "Other Centres - Affected",
  otherCentresEntered: "Other Centres - No Entered For Unit",
  otherCentresDirectlyAffected: "Other Centres - Directly Affected",
  otherCentresIndirectlyAffected: "Other Centres - Indirectly Affected",
  otherLearnersEntered: "Other Learners - No Entered For Unit",
  otherLearnersDirectlyAffected: "Other Learners - Directly Affected",
  otherLearnersIndirectlyAffected: "Other Learners - Indirectly Affected",
  assessmentMaterialError: "Assessment Material Error",
  amePaperType: "Assessment Type",
  eventNotificationAMEModificationType: "Type of Modification (if applicable)",
  eventNotificationAMEWhenIdentified: "When Identified",
  eventNotificationAMEWhoIdentified: "Who Identified it?",
  eventNotificationAMEAssessmentMethod: "Assessment Method",
  securityBreach: "Security Breach",
  eventNotificationSecurityBreachMeans: "Means of Breach",
  securityBreachEvidenceOfTwoPeoplePresent:
    "Evidence of Two People Present at Opening",
  securityBreachIncorrectPaperOutcome: "Incorrect Paper Outcome",
  declaringNonCompliance: "Are You Declaring Non-Compliance",
  eventNotificationDeclaredNonComplianceGeneralCondition: "General Conditions",
  eventNotificationDeclaredNonComplianceGeneralSubCondition: "General Sub Conditions",
  eventNotificationDeclaredNonComplianceQualCondition:
    "Qualification Conditions",
  eventNotificationDeclaredNonComplianceSubjectCondition: "Subject Conditions",
  actionsTakenToIdentifyCauseAndEffect: "Identify Cause and Effect",
  actionsTakenToMitigateAdverseEffect: "Mitigate the Adverse Effect",
  actionsTakenToPreventReoccurrencce: "Prevent re-occurrence",
  inherentRiskImpact: "Inherent Risk Impact",
  inherentRiskLikelihood: "Inherent Risk Likelihood",
  residualRiskImpact: "Residual Risk Impact",
  residualRiskLikelihood: "Residual Risk Likelihood",
  caseSummary: "Case Summary",
  eventType: "Event Type",
  eventSubType: "Event Sub-type",
  ofqualEventManagementActivities: "Ofqual Event Management Activities",
  typeOfQualVtq: "Type of Qualification VTQ",
  typeOfQualGq: "Type of Qualification GQ",
  directorate: "Directorate",
  riskCategory: "Risk Category",
  amecategory: "Assessment Material Error Category",
  numMarksAffected: "Marks Affected",
  numMarksTotal: "Total Marks",
  numGradesDecreasedIdentified: "No. of Grades Decreased Identified",
  numGradesDecreasedAmended: "No. of Grades Decreased Amended",
  numGradesIncreasedIdentified: "No. of Grades Increased Identified",
  numGradesIncreasedAmended: "No. of Grades Increased Amended",
  rootCause: "Root Cause",
  rootCauseDetails: "Root Cause Details",
  eventNotificationOfqualMitigationTaken: "Mitigations Taken",
  eventNotificationOfqualPreventReoccurrence: "Prevent re-occurrence",
  ofqualFollowUpDate: "Ofqual Follow Up Date",
  eventNotificationOfqualActionTaken: "Ofqual Action Taken",
  ofqualActionTakenRationale: "Rationale",
  adverseEffectOutcome: "Adverse Effect Outcome",
  agreeWithAodeclaration: "Do we agree with the AO's declaration?",
  disagreeWithAodeclarationReason: "Disagree with AO declaration reason",
  finalDetermination: "Final Determination",
  aoengagement: "AO engagement",
  malpracticeAllegation: "Malpractice allegation",
  eventNotificationIndicatedNonComplianceGeneralCondition:
    "Indicated Non Compliance General Conditions",
  eventNotificationIndicatedNonComplianceGeneralSubCondition:
    "General Sub Conditions",
  eventNotificationIndicatedNonComplianceQualCondition:
    "Indicated Non Compliance Qualification Conditions",
  eventNotificationIndicatedNonComplianceSubjectCondition:
    "Indicated Non Compliance Subject Conditions",
  "eventNotificationCentres.centreNumberType": "Centre Number Type",
  "eventNotificationCentres.centreNumber": "Centre Number",
  "eventNotificationCentres.centreName": "Centre Name",
  "affectedQualifications.id": "Affected Qualification",
  "eventNotificationExamSeries.series": "Exam Series",
  "eventNotificationExamSeries.year": "Exam Year",
  aoReference: "AO reference",
  resourceTags: "Tag(s)",
  eventNotificationExamDate: "Assessment date",
  eventNotificationExamTime: "AM/PM", 
  enOfqualIndicatedNonComplianceGeneralCondition:  "Indicated general condition", 
  enOfqualIndicatedNonComplianceGeneralSubCondition: "Indicated general sub condition",
  enOfqualIndicatedNonComplianceQualCondition: "Indicated qual condition",
  enOfqualIndicatedNonComplianceSubjectCondition: "Indicated subject condition",
  enOfqualNonComplianceGeneralCondition: "Non compliance general condition", 
  enOfqualNonComplianceGeneralSubCondition: "Non compliance general sub condition",
  enOfqualNonComplianceQualCondition: "Non compliance qual condition",
  enOfqualNonComplianceSubjectCondition: "Non compliance subject condition"
};
